module.exports = __webpack_public_path__ + "img/small_eye_chart03.7c4e9e00.jpg";